module.exports = __webpack_public_path__ + "img/just_text_light2.cb9b50ff.png";